let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("TkY5q")).then(() => parcelRequire('4Ym1v'));